import { sendCarouselLog } from "api/common/carousel"
import { useEffect } from "react"

const OpenNewLink = () => {

    useEffect(() => {
        sendCarouselLog({ carouselId: 23288 }).then(() => {
            window.open("https://game.academy.163.com/event/yysls", "_self")
        })
    }, [])

    return <div></div>
}

export default OpenNewLink
